import { Table, Modal, Typography, Space, Tag } from "antd";
import { ColumnType } from "antd/lib/table";
import {
	ETransferMemberTeamStatus,
	ListTransferMemberTeamQuery,
	TransferMemberTeamProperties,
} from "../../../types/transferMemberTeam.type";
import CustomPagination from "../../../components/CustomPagination";
import useFetchList from "../../../hooks/useFetchList";
import { useEffect } from "react";
import { formatYearToTime } from "../../../helpers/format";
import { EFeeType } from "../../../types/masterFee.type";
import { priceFormat } from "../../../helpers/priceFormat";
import { floatToPercentageWithFixed } from "../../../helpers/number";

const { Title } = Typography;

interface MemberTransferHistoryProps {
	title?: string;
	userId: string | undefined;
	open?: boolean;
	onClose?: () => void;
	type: "modal" | "table";
}
const MemberTransferHistory: React.FC<MemberTransferHistoryProps> = ({ userId, open, onClose, title, type }) => {
	const { isLoading, data, pagination, changePage, setQuery, query } = useFetchList<
		TransferMemberTeamProperties,
		ListTransferMemberTeamQuery
	>({
		endpoint: "transfer-member-teams",
		initialQuery: {
			sort: "createdAt:DESC",
			includeData: "originGroupMember,toGroupMember,originGroup,toGroup",
			filterUserId: userId,
			filterStatus: ETransferMemberTeamStatus.TRANSFERED,
		},
	});

	useEffect(() => {
		if (userId) {
			setQuery({
				...query,
				filterUserId: userId,
			});
		}

		// eslint-disable-next-line
	}, [userId]);

	const COLUMNS: ColumnType<TransferMemberTeamProperties>[] = [
		{
			title: "FROM TEAM",
			key: "originGroup",
			dataIndex: ["originGroup", "groupName"],
		},
		{
			title: "TO TEAM",
			key: "toGroup",
			dataIndex: ["toGroup", "groupName"],
		},
		// {
		// 	title: "FROM FEE",
		// 	key: "fromCommission",
		// 	dataIndex: ["originGroupMember", "teamLeaderCommission"],
		// 	render: (value: number, record: TransferMemberTeamProperties) => {
		// 		return (
		// 			<Space size={2}>
		// 				{/* {record?.originGroupMember?.teamsMemberFees.map((fee) => (
		// 					<Tag style={{ padding: "2px 8px" }}>
		// 						{fee.type === EFeeType.AMOUNT
		// 							? `Rp ${priceFormat(fee.value)}`
		// 							: `${floatToPercentageWithFixed(fee.value)}%`}
		// 					</Tag>
		// 				))} */}
		// 			</Space>
		// 		);
		// 	},
		// },
		// {
		// 	title: "TO FEE",
		// 	key: "toCommission",
		// 	dataIndex: ["toGroupMember", "teamLeaderCommission"],
		// 	render: (value: number, record: TransferMemberTeamProperties) => {
		// 		return (
		// 			<Space size={2}>
		// 				{/* {record?.toGroupMember?.teamsMemberFees.map((fee) => (
		// 					<Tag style={{ padding: "2px 8px" }}>
		// 						{fee.type === EFeeType.AMOUNT
		// 							? `Rp ${priceFormat(fee.value)}`
		// 							: `${floatToPercentageWithFixed(fee.value)}%`}
		// 					</Tag>
		// 				))} */}
		// 			</Space>
		// 		);
		// 	},
		// },
		{
			title: "TRANSFERRED AT",
			key: "transferedAt",
			dataIndex: "createdAt",
			render: (value: string) => {
				return formatYearToTime(value);
			},
		},
		{
			title: "TRANSFERRED BY",
			key: "transferedBy",
			dataIndex: ["createdByUserMeta", "name"],
		},
	];

	return type === "modal" ? (
		<Modal
			title={title ?? "History Transfer"}
			open={open}
			onCancel={onClose}
			destroyOnClose={true}
			width="75%"
			footer={null}
		>
			<Table
				className="table-grey-header"
				loading={isLoading}
				columns={COLUMNS}
				dataSource={data}
				rowKey="transferMemberId"
				pagination={false}
			/>
			<CustomPagination
				current={pagination.page}
				total={pagination.totalData}
				defaultPageSize={pagination.perPage}
				pageSize={pagination.perPage}
				onChange={changePage}
			/>
		</Modal>
	) : (
		<>
			<Title
				level={5}
				style={{ marginTop: 20 }}
			>
				{title ?? "History Transfer"}
			</Title>
			<Table
				className="table-grey-header"
				loading={isLoading}
				columns={COLUMNS}
				dataSource={data}
				rowKey="transferMemberId"
				pagination={false}
			/>
			<CustomPagination
				current={pagination.page}
				total={pagination.totalData}
				defaultPageSize={pagination.perPage}
				pageSize={pagination.perPage}
				onChange={changePage}
			/>
		</>
	);
};
export default MemberTransferHistory;
